import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'pfx',
      name: i18n.t('tipos.certificate.pfx'),
      disabled: false
    },
    {
      id: 'srl',
      name: i18n.t('tipos.certificate.srl'),
      disabled: true
    },
    {
      id: 'usr',
      name: i18n.t('tipos.certificate.usr'),
      disabled: true
    }
  ]
}

export function TIPOS_CERT (state) {
  return configHelper.getConfig(state, 'TIPOS_CERT', GenerateConfig)
}
